export const ROUTES = {
  LOGIN: '/login',
  FORGOTPASSWORD: '/forgotpassword',
  REGISTER: '/signup',
  HOMEPAGE: '/',
  CATELOG: '/manage-catelog',
  RESET_PASSWORD: '/forgot_password',
};
